import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DeclarationPage from "./pages/DeclarationPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/declaration/101-01292611-26" replace />} />
          <Route path="/declaration/:decNo" element={<DeclarationPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
